module.exports = __webpack_public_path__ + "static/D-453e62b9d5ff13610a41272d7ea07c84.jpg";